import React, { useState, useEffect, useMemo } from "react";
import FlightDetail from '../Components/FlightDetail';
import FlightSearchFormDetailPage from '../Components/FlightSearchFormDetailPage';



function FlightSearchDetail() {


   return (
    <>
      
      <FlightSearchFormDetailPage />
      <FlightDetail/>

      
    </>
  );
}
export default FlightSearchDetail;
